import PlaylistAssignmentsTablePage from './PlaylistAssignmentsTablePage';
import PlaylistAssignmentsPortalsTable from './PlaylistAssignmentsPortalsTable';
import PlaylistAssignmentsPortalsList from './PlaylistAssignmentsPortalsList';
import PlaylistAssignmentsBlankPage from './PlaylistAssignmentsBlankPage';
import PlaylistAssignmentsForPortal from './PlaylistAssignmentsForPortal';
import { useFilteredPlaylistAssignmentsPortals, usePlaylistAssignmentsParams } from '../playlistAssignmentsHooks';
import { getPlaylistAssignmentsUrl } from '../playlistAssignmentsUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FILTER_TYPES } from '../../../constants/TopFilterConstants';
import useNavigate from '../../../hooks/useNavigate';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { AssignPlaylistButton } from './AssignPlaylistButton';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const PlaylistAssignmentsPortalsCount = ({
  count,
  total
}) => {
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: `learningCenter.playlistAssignments.portalsCount`,
    options: {
      count,
      total
    }
  });
};
const PlaylistAssignmentsPortals = ({
  playlistId: propPlaylistId
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const {
    playlistId: paramPlaylistId
  } = usePlaylistAssignmentsParams();
  const playlistId = propPlaylistId || paramPlaylistId;
  const navigate = useNavigate();
  const {
    total,
    playlistAssignmentsPortals,
    playlistAssignmentsPortalsLoading,
    query
  } = useFilteredPlaylistAssignmentsPortals({
    playlistId
  });
  if (!playlistId || playlistAssignmentsPortalsLoading) return null;
  if (!total && !(query !== null && query !== void 0 && query.length)) return /*#__PURE__*/_jsx(PlaylistAssignmentsBlankPage, {
    playlistId: playlistId
  });

  // render assignments directly if it only has one portal
  if (total === 1 && playlistAssignmentsPortals && playlistAssignmentsPortals.length && !(query !== null && query !== void 0 && query.length)) return /*#__PURE__*/_jsx(PlaylistAssignmentsForPortal, {
    playlistId: playlistId,
    portalId: playlistAssignmentsPortals[0].portal.id
  });
  const handleOnRowOpenChange = portalId => navigate(getPlaylistAssignmentsUrl(playlistId, portalId));
  return /*#__PURE__*/_jsx(PlaylistAssignmentsTablePage, {
    actions: /*#__PURE__*/_jsx(Flex, {
      overflow: "visible",
      children: /*#__PURE__*/_jsx(AssignPlaylistButton, {
        playlistId: playlistId
      })
    }),
    headerTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.playlistAssignments.portalsHeader"
    }),
    searchFilter: FILTER_TYPES.SEARCH_ACCOUNTS,
    tableCount: playlistAssignmentsPortals && total !== undefined && /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsCount, {
      count: playlistAssignmentsPortals.length,
      total: total
    }),
    children: isMobile ? /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsList, {
      onRowClick: ({
        portal: {
          portal: {
            id
          }
        }
      }) => handleOnRowOpenChange(id),
      playlistId: playlistId
    }) : /*#__PURE__*/_jsx(PlaylistAssignmentsPortalsTable, {
      playlistId: playlistId
    })
  });
};
export default PlaylistAssignmentsPortals;